export default (promise, signal = null) =>
  !signal
    ? promise
    : new Promise((resolve, reject) => {
        signal.throwIfAborted();

        const abortHandler = (event) => {
          // Remove all references. If the promise is resolved, promise.then() will do nothing
          fulfilled = promise = signal = null;
          reject(event.reason);
        };
        let fulfilled = (result) => {
          resolve(result);
          signal.removeEventListener('abort', abortHandler);
        };
        promise.then((result) => fulfilled?.(result));
        signal.addEventListener('abort', abortHandler, { once: true });
      });
